import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import styles from './SuggestedModuleDeleteModal.module.sass';

type SuggestedModuleDeleteModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const SuggestedModuleDeleteModal = ({
  opened,
  onClose,
  onConfirm,
  isDeleting,
}: SuggestedModuleDeleteModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Delete Suggested Module?"
      centered
      classNames={{
        header: styles.modalHeader,
        title: styles.modalTitle,
        close: styles.closeButton,
      }}
    >
      <Stack mt="md">
        <Text>Are you sure you want to delete this suggested module?</Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={isDeleting}>
            No
          </Button>
          <Button color="red" onClick={onConfirm} loading={isDeleting}>
            Yes
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
